export const actionTypes = {
  CHANGE_MODAL: 'CHANGE_MODAL'
}   
export const changeModal = (payload) => ({
  type: actionTypes.CHANGE_MODAL,
  payload
})
